import React, { useEffect, useRef } from 'react'
import { Button, Card, Descriptions, Space, Typography } from 'antd'
import { ArrowRightOutlined, CheckCircleFilled } from '@ant-design/icons'
import { capitalize } from '../../util/format'
import { SummaryItem } from './EntitySummary'
const { Title, Text } = Typography

interface CreatedTicketProps {
    // e.g. 'funding'
    noun: string
    id: string
    details?: SummaryItem[]
    onUpdateStatus: () => void
    onCreateAnother: () => void
}

const CreatedTicket: React.FC<CreatedTicketProps> = ({ noun, id, details = [], onUpdateStatus, onCreateAnother }) => {
    const shown = details.filter((detail) => detail.value !== undefined && detail.value !== null && detail.value !== '')
    const updateStatusButton = useRef<HTMLButtonElement>(null)

    // Moving focus here also closes any dropdown still open in the (now hidden) form
    useEffect(() => {
        updateStatusButton.current?.focus()
    }, [])

    return (
        <Card className="created-ticket">
            <CheckCircleFilled className="created-ticket-icon" />
            <Title level={3}>{capitalize(noun)} created</Title>
            <Text type="secondary">Keep this ID, you need it to change the {noun}’s status.</Text>

            <div>
                <div className="created-ticket-id">
                    <Text type="secondary">{capitalize(noun)} ID</Text>
                    <Text copyable className="created-ticket-id-value">
                        {id}
                    </Text>
                </div>
            </div>

            {shown.length > 0 && (
                <Descriptions column={{ xs: 1, sm: 2 }} size="small" colon={false}>
                    {shown.map((detail) => (
                        <Descriptions.Item key={detail.label} label={detail.label}>
                            {detail.value}
                        </Descriptions.Item>
                    ))}
                </Descriptions>
            )}

            <Space wrap>
                <Button ref={updateStatusButton} type="primary" size="large" onClick={onUpdateStatus}>
                    Update status <ArrowRightOutlined />
                </Button>
                <Button size="large" onClick={onCreateAnother}>
                    Create another
                </Button>
            </Space>
        </Card>
    )
}

export default CreatedTicket
